import { ERequestApiStatus } from '../types/appState';
import { TChatImages } from '../types/chatFiles';
import { TChatHint } from '../types/chatHint';
import { TChatInListSchema } from '../types/chatList';
import { TOffer } from '../types/offer';
import { TFrameCompanion, TOpenedChat, TOpenedChats } from '../types/openedChats';

type TNewChat = {
  agentId: number | null;
  offerData?: TOffer;
  hintQuestions?: TChatHint[];
  frameCompanion?: TFrameCompanion;
  defaultMessage?: string;
  sendDefaultMessage?: boolean;
  gaLabel?: string;
  gaProducts?: never;
  checkin: string | null;
  checkout: string | null;
};

type TAddNewChatProps = {
  openedChats: TOpenedChats;
  chats: TChatInListSchema[];
  currentChatId: string;
  chatImages?: TChatImages | null;
  newChat?: TNewChat;
};

export const addNewChat = ({
  openedChats,
  chats,
  currentChatId,
  newChat,
  chatImages,
}: TAddNewChatProps): TOpenedChats => {
  if (
    typeof openedChats[currentChatId] === 'object' &&
    'pages' in openedChats[currentChatId] &&
    'currentTimestamp' in openedChats[currentChatId]
  ) {
    return {
      ...openedChats,
      [currentChatId]: {
        ...openedChats[currentChatId],
        status: ERequestApiStatus.Pending,
      },
    };
  }

  const {
    agentId,
    offerData,
    frameCompanion,
    defaultMessage,
    sendDefaultMessage,
    hintQuestions = [],
    gaLabel,
    gaProducts,
    checkin,
    checkout,
  } = newChat || {};

  const currentChat = chats.find(chat => chat.chatId === currentChatId);

  const newOpenedChat: TOpenedChat = {
    agentId,
    chatId: currentChatId as string,
    currentTimestamp: undefined,
    offer: currentChat?.data?.offer || offerData,
    firstMessageStatus: null,
    pages: [],
    pendingFiles: null,
    images: chatImages || null,
    frameCompanion,
    editableMessage: defaultMessage,
    sendDefaultMessage,
    hintQuestions: {
      hints: hintQuestions,
      isVisible: hintQuestions.length > 0,
    },
    ga: {
      label: gaLabel,
      products: gaProducts,
    },
    availableDates: {
      checkin,
      checkout,
    },
    status: ERequestApiStatus.Pending,
    error: null,
  };

  return {
    ...openedChats,
    [currentChatId]: newOpenedChat,
  };
};
